"use client"

import { createContext, useContext, useMemo, useState, type ReactNode } from "react"

interface MobileSearchState {
  open: boolean
  setOpen: (open: boolean) => void
}

const MobileSearchContext = createContext<MobileSearchState | undefined>(undefined)

export const MobileSearchProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false)
  const value = useMemo(() => ({ open, setOpen }), [open])
  return <MobileSearchContext.Provider value={value}>{children}</MobileSearchContext.Provider>
}

export const useMobileSearchState = (): MobileSearchState => {
  const shared = useContext(MobileSearchContext)
  const [localOpen, setLocalOpen] = useState(false)
  return shared ?? { open: localOpen, setOpen: setLocalOpen }
}
